import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m3.122 13.873 6.236-8.467c.3-.408.984-.408 1.284 0l6.236 8.467c.326.444-.039 1.027-.643 1.027H3.765c-.604 0-.97-.583-.643-1.027Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=TriangleIcon20.js.map